// Segment analytics web client, for mobile clients see .android and .ios files
export default window.analytics;
